enum SearchSource {
  ApplyFilters = 'ApplyFilters',
  Facet = 'Facet',
  InitialPageLoad = 'InitialPageLoad',
  Location = 'Location',
  Pagination = 'Pagination',
  RecentSearch = 'RecentSearch',
  SavedSearch = 'SavedSearch',
  SortBy = 'SortBy',
  TagRemoved = 'TagRemoved',
  TextSearch = 'TextSearch',
  Tile = 'Tile'
}

export default SearchSource;
